import React from "react";

import classNames from "classnames";

import { AsyncStatuses } from "../types/shared";

interface LoadingProps {
    className?: string;
    useContext?: () => {
        fetchStatus: AsyncStatuses;
    };
    centered?: boolean;
}

const Loading = ({
    className,
    useContext,
    centered = false,
}: LoadingProps): React.JSX.Element => {
    let fetchStatus: AsyncStatuses;
    if (useContext) {
        fetchStatus = useContext().fetchStatus;
    }

    return (
        <div
            className={classNames(className, {
                spinnerContainer: centered,
                "d-none": useContext && fetchStatus !== "pending",
            })}
            data-testid="loadingSpinner"
        >
            <div className="loadingSpinner">
                <svg id="ball" width="30" height="30" viewBox="0 0 46.6 46.6">
                    <circle fill="#ffffff" cx="23.3" cy="23.3" r="23.3" />
                    <path
                        fill="#D7172A"
                        d="M22.4 16.4c-5.6 0-11.9-1.2-18.1-4.8 -1.2-0.7-1.6-2.2-0.9-3.4C4.1 7 5.7 6.6 6.9 7.3c15.6 9.2 32.8 0.1 32.9 0 1.2-0.7 2.7-0.2 3.4 1 0.7 1.2 0.2 2.7-1 3.4C41.7 11.9 33.3 16.4 22.4 16.4z"
                    />
                    <path
                        fill="#D7172A"
                        d="M5.6 39.1c-0.9 0-1.7-0.5-2.2-1.3 -0.7-1.2-0.2-2.7 1-3.4 0.8-0.4 19.7-10.6 37.9 0 1.2 0.7 1.6 2.2 0.9 3.4s-2.2 1.6-3.4 0.9C24 29.5 7 38.7 6.8 38.8 6.4 39 6 39.1 5.6 39.1z"
                    />
                </svg>
            </div>
        </div>
    );
};

export default Loading;
